var SocialLatestSolutions = {
  init: function() {
    this.setVariables();
    this.retrieveSolutions();
  },
  setVariables: function() {
    this.$latestSolutionsList = $("#latestSolutionsList");
    this.$noLatestSolutions = $("#noLatestSolutions");
  },
  retrieveSolutions: function() {
    var _self = this;

    var url = Config.contextPath + "/controller/search/recentsolutions/"
    var data = {
      hitcount: 5,
      timerange: "lastweek",
      SToken: Config.csrf.value,
      format: "json"
    };

    $.post(url, data)
      .done(function(r) {

        if(r.error){
          alert(r.errorMessage);
          return;
        }

        var count = r.recentSolutions.length;
        if (count <= 0) {
          _self.$noLatestSolutions.removeClass("hide");
          _self.$latestSolutionsList.addClass("hide");
          return;
        }

		let target = "";
		if (launchLinksInNewWindow) {
			target = `_blank`;
		} else {
			target = `_self`;
		}

        $.each(r.recentSolutions, function(i, solution) {
          var $li = $("<li></li>");
          var $href = $("<a></a>");
          $href.attr("href", Config.contextPath + "/app/portlets/results/viewsolution.jsp?solutionid=" + solution.id + simplifiedSocialLayoutParam + launchLinksInNewWindowParam);
		  $href.attr("target", target);
          $href.html(solution.problem);
          $li.append($href);
          _self.$latestSolutionsList.append($li);
        });

      });
  }
};
